import React, { useState, useEffect } from "react";
import Header from "../../../Componets/Header";
import Loadercomponent from "../../../Componets/Loader";
import ScrollWrapper from "../../../Componets/ScrollWrapper";
import headers from "../../../Data/Tables/Settings/Branches/headers";
import { get_all_main_branches } from "../../../Controllers/Settings/Branches";
import toast from "react-hot-toast";
import {
    BankOutlined,
    ShopOutlined,
    UserOutlined,
    TeamOutlined,
    ApartmentOutlined,
    MailOutlined,
    PhoneOutlined,
    GlobalOutlined,
    CalendarOutlined,
    CrownOutlined,
    StarOutlined,
    ThunderboltOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    EyeOutlined,
    DownOutlined,
    RightOutlined,
    SearchOutlined,
    ReloadOutlined,
    FilterOutlined,
    SortAscendingOutlined,
    SortDescendingOutlined,
    DeleteOutlined,
    EditOutlined,
    MoreOutlined,
    LoginOutlined,
    LogoutOutlined,
    ClockCircleOutlined
} from "@ant-design/icons";

const BranchesDisplay = () => {
    const [header, setHeader] = useState(headers);
    const [loader, setLoader] = useState(false);
    const [branches, setBranches] = useState([]);
    const [filteredBranches, setFilteredBranches] = useState([]);
    const [expandedRows, setExpandedRows] = useState({});
    const [expandedSubRows, setExpandedSubRows] = useState({});
    const [searchTerm, setSearchTerm] = useState("");
    const [planFilter, setPlanFilter] = useState("all");
    const [statusFilter, setStatusFilter] = useState("all");
    const [sortConfig, setSortConfig] = useState({ key: "name", direction: "asc" });
    const [summary, setSummary] = useState({
        total_main_branches: 0,
        total_sub_branches: 0,
        total_users_all_branches: 0
    });

    const PLANS = {
        1: { name: "Premium", icon: CrownOutlined, color: "amber", bg: "bg-amber-100", text: "text-amber-700", border: "border-amber-200" },
        403: { name: "Premium", icon: CrownOutlined, color: "amber", bg: "bg-amber-100", text: "text-amber-700", border: "border-amber-200" },
        1000: { name: "Basic", icon: StarOutlined, color: "blue", bg: "bg-blue-100", text: "text-blue-700", border: "border-blue-200" },
        2000: { name: "Standard", icon: ThunderboltOutlined, color: "green", bg: "bg-green-100", text: "text-green-700", border: "border-green-200" }
    };

    const getPlanDetails = (planId) => {
        if (planId === 1 || planId === 403) return PLANS[1];
        return PLANS[planId] || { name: "Unknown", icon: StarOutlined, color: "gray", bg: "bg-gray-100", text: "text-gray-700", border: "border-gray-200" };
    };

    const fetchBranches = async () => {
        try {
            setLoader(true);
            const response = await get_all_main_branches();

            if (response?.status) {
                setBranches(response?.data?.data || []);
                setFilteredBranches(response?.data?.data || []);
                setSummary(response?.data?.summary || {
                    total_main_branches: 0,
                    total_sub_branches: 0,
                    total_users_all_branches: 0
                });
            } else {
                toast?.error(response?.message || "Failed to fetch branches");
            }
        } catch (error) {
            console.error("Error fetching branches:", error);
            toast?.error("An error occurred while fetching branches");
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchBranches();
    }, []);

    useEffect(() => {
        let filtered = [...branches];

        if (searchTerm) {
            filtered = filtered.filter(branch =>
                branch.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                branch.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                branch.phone?.includes(searchTerm) ||
                branch.ref?.toString().includes(searchTerm)
            );
        }

        if (planFilter !== "all") {
            filtered = filtered.filter(branch => branch.plan == planFilter);
        }

        filtered.sort((a, b) => {
            let aVal = a[sortConfig.key];
            let bVal = b[sortConfig.key];

            if (sortConfig.key === "created_date") {
                aVal = new Date(aVal).getTime();
                bVal = new Date(bVal).getTime();
            }

            if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
            if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
            return 0;
        });

        setFilteredBranches(filtered);
    }, [searchTerm, planFilter, sortConfig, branches]);

    const toggleRowExpand = (branchId) => {
        setExpandedRows(prev => ({
            ...prev,
            [branchId]: !prev[branchId]
        }));
    };

    const toggleSubRowExpand = (branchId, subBranchId) => {
        const key = `${branchId}-${subBranchId}`;
        setExpandedSubRows(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    const handleSort = (key) => {
        setSortConfig(prev => ({
            key,
            direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc"
        }));
    };

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return null;
        return sortConfig.direction === "asc" ?
            <SortAscendingOutlined className="w-4 h-4 ml-1" /> :
            <SortDescendingOutlined className="w-4 h-4 ml-1" />;
    };

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        return new Date(dateString).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric"
        });
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return "N/A";
        return new Date(dateString).toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        });
    };

    const formatDateExpiry = (createdDate, renewedYear) => {
        const created = new Date(createdDate);
        const expiryYear = parseInt(renewedYear) + 1;
        const expiryDate = new Date(created);
        expiryDate.setFullYear(expiryYear);


        return formatDate(expiryDate.toISOString());
    }

    const StatsBar = () => (
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            <div className="bg-gradient-to-br from-indigo-500 to-indigo-600 rounded-xl p-4 text-white">
                <div className="flex items-center justify-between">
                    <div>
                        <p className="text-sm opacity-90">Total Main Branches</p>
                        <p className="text-2xl font-bold">{summary.total_main_branches}</p>
                    </div>
                    <BankOutlined className="w-8 h-8 opacity-80" />
                </div>
            </div>
            <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-xl p-4 text-white">
                <div className="flex items-center justify-between">
                    <div>
                        <p className="text-sm opacity-90">Total Sub Branches</p>
                        <p className="text-2xl font-bold">{summary.total_sub_branches}</p>
                    </div>
                    <ShopOutlined className="w-8 h-8 opacity-80" />
                </div>
            </div>
            <div className="bg-gradient-to-br from-amber-500 to-amber-600 rounded-xl p-4 text-white">
                <div className="flex items-center justify-between">
                    <div>
                        <p className="text-sm opacity-90">Total Users</p>
                        <p className="text-2xl font-bold">{summary.total_users_all_branches}</p>
                    </div>
                    <TeamOutlined className="w-8 h-8 opacity-80" />
                </div>
            </div>
            <div className="bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl p-4 text-white">
                <div className="flex items-center justify-between">
                    <div>
                        <p className="text-sm opacity-90">Active Branches</p>
                        <p className="text-2xl font-bold">
                            {branches.filter(b => b.sub_branches?.some(sb => sb.status === 1) || b.main_branch_users?.length > 0).length}
                        </p>
                    </div>
                    <CheckCircleOutlined className="w-8 h-8 opacity-80" />
                </div>
            </div>
        </div>
    );


    const UserTable = ({ users, title, showLoginInfo = true }) => (
        <div className="mt-4">
            <h5 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
                <TeamOutlined className="w-4 h-4 mr-2 text-indigo-600" />
                {title} ({users.length})
            </h5>
            <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">User</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Contact</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Role</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                            {showLoginInfo && (
                                <>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Last Login</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Last Logout</th>
                                </>
                            )}
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {users.map((user) => (
                            <tr key={user.id} className="hover:bg-gray-50 transition-colors">
                                <td className="px-4 py-3">
                                    <div className="flex items-center">
                                        <div className={`w-8 h-8 rounded-full flex items-center justify-center ${user.role === 'SUPERADMIN' ? 'bg-purple-100' : 'bg-blue-100'
                                            }`}>
                                            <UserOutlined className={`w-4 h-4 ${user.role === 'SUPERADMIN' ? 'text-purple-600' : 'text-blue-600'
                                                }`} />
                                        </div>
                                        <div className="ml-3">
                                            <p className="text-sm font-medium text-gray-900">{user.name}</p>
                                            <p className="text-xs text-gray-500">ID: {user.id.slice(-6)}</p>
                                        </div>
                                    </div>
                                </td>
                                <td className="px-4 py-3">
                                    <p className="text-sm text-gray-900 flex items-center">
                                        <MailOutlined className="w-3 h-3 mr-1 text-gray-400" />
                                        {user.email || 'N/A'}
                                    </p>
                                    <p className="text-xs text-gray-500 flex items-center mt-1">
                                        <PhoneOutlined className="w-3 h-3 mr-1 text-gray-400" />
                                        {user.phone || 'N/A'}
                                    </p>
                                </td>
                                <td className="px-4 py-3">
                                    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${user.role === 'SUPERADMIN'
                                        ? 'bg-purple-100 text-purple-700'
                                        : 'bg-blue-100 text-blue-700'
                                        }`}>
                                        {user.role === 'SUPERADMIN' ? 'SUPERADMIN' : user.role.slice(-6)}
                                    </span>
                                </td>
                                <td className="px-4 py-3">
                                    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${user.status === 1 ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                                        }`}>
                                        {user.status === 1 ? 'Active' : 'Inactive'}
                                    </span>
                                </td>
                                {showLoginInfo && (
                                    <>
                                        <td className="px-4 py-3">
                                            {user.login ? (
                                                <div className="flex items-center text-xs text-gray-600">
                                                    <LoginOutlined className="w-3 h-3 mr-1 text-green-500" />
                                                    {formatDateTime(user.login)}
                                                </div>
                                            ) : (
                                                <span className="text-xs text-gray-400">Never</span>
                                            )}
                                        </td>
                                        <td className="px-4 py-3">
                                            {user.logout ? (
                                                <div className="flex items-center text-xs text-gray-600">
                                                    <LogoutOutlined className="w-3 h-3 mr-1 text-red-500" />
                                                    {formatDateTime(user.logout)}
                                                </div>
                                            ) : (
                                                <span className="text-xs text-gray-400">Not logged out</span>
                                            )}
                                        </td>
                                    </>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );

    const SubBranchTable = ({ subBranches, mainBranchId, depth = 0 }) => {
        return (
            <div className={`${depth > 0 ? 'ml-8' : ''} space-y-3 mt-3`}>
                {subBranches.map((subBranch) => {
                    const isExpanded = expandedSubRows[`${mainBranchId}-${subBranch._id}`];
                    const PlanIcon = getPlanDetails(subBranch.plan).icon;
                    const planDetails = getPlanDetails(subBranch.plan);

                    return (
                        <div key={subBranch._id} className="border border-gray-200 rounded-lg overflow-hidden">
                            <div className="bg-gray-50 px-4 py-3 flex items-center justify-between hover:bg-gray-100 transition-colors">
                                <div className="flex items-center flex-1">
                                    <div className={`w-8 h-8 rounded-lg flex items-center justify-center mr-3 ${depth === 0 ? 'bg-green-100' : 'bg-teal-100'
                                        }`}>
                                        <ShopOutlined className={`w-4 h-4 ${depth === 0 ? 'text-green-600' : 'text-teal-600'
                                            }`} />
                                    </div>
                                    <div className="flex-1 grid grid-cols-12 gap-2 text-sm">
                                        <div className="col-span-3">
                                            <p className="font-medium text-gray-900">{subBranch.name}</p>
                                            <p className="text-xs text-gray-500">ID: {subBranch._id.slice(-6)}</p>
                                        </div>
                                        <div className="col-span-2">
                                            <p className="text-gray-600">{subBranch.phone}</p>
                                            <p className="text-xs text-gray-500 truncate">{subBranch.email}</p>
                                        </div>
                                        <div className="col-span-2">
                                            <span className={`inline-flex items-center px-2 py-1 rounded-lg text-xs font-medium ${planDetails.bg} ${planDetails.text}`}>
                                                <PlanIcon className="w-3 h-3 mr-1" />
                                                {planDetails.name}
                                            </span>
                                        </div>
                                        <div className="col-span-2">
                                            <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${subBranch.status === 1 ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'
                                                }`}>
                                                {subBranch.status === 1 ? 'Active' : 'Inactive'}
                                            </span>
                                        </div>
                                        <div className="col-span-2">
                                            <p className="text-gray-600 flex items-center">
                                                <TeamOutlined className="w-3 h-3 mr-1" />
                                                {subBranch.total_users_with_nested || 0} Users
                                            </p>
                                        </div>
                                        <div className="col-span-1">
                                            <p className="text-xs text-gray-500">{formatDate(subBranch.created_date)}</p>
                                        </div>
                                    </div>
                                </div>
                                <button
                                    onClick={() => toggleSubRowExpand(mainBranchId, subBranch._id)}
                                    className="ml-2 p-1 hover:bg-gray-200 rounded-lg transition-colors"
                                >
                                    {isExpanded ? (
                                        <DownOutlined className="w-4 h-4 text-gray-600" />
                                    ) : (
                                        <RightOutlined className="w-4 h-4 text-gray-600" />
                                    )}
                                </button>
                            </div>

                            {isExpanded && (
                                <div className="p-4 bg-white border-t border-gray-200">
                                    {subBranch.users?.length > 0 && (
                                        <UserTable
                                            users={subBranch.users}
                                            title={`Users in ${subBranch.name}`}
                                            showLoginInfo={true}
                                        />
                                    )}

                                    {subBranch.sub_branches?.length > 0 && (
                                        <div className="mt-4">
                                            <h5 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
                                                <ApartmentOutlined className="w-4 h-4 mr-2 text-teal-600" />
                                                Nested Sub Branches ({subBranch.sub_branches.length})
                                            </h5>
                                            <SubBranchTable
                                                subBranches={subBranch.sub_branches}
                                                mainBranchId={mainBranchId}
                                                depth={depth + 1}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <Header headers={header} setHeaders={setHeader}>
            <Loadercomponent loader={loader}>
                <ScrollWrapper summary={2}>
                    <div className="p-6 space-y-6">
                        <div className="flex items-center justify-between">
                            <div>
                                <h1 className="text-2xl font-bold text-gray-800">Branch Management</h1>
                                <p className="text-gray-500 mt-1">
                                    Comprehensive view of all branches, sub-branches, and users
                                </p>
                            </div>
                            <div className="flex items-center space-x-2 bg-indigo-50 px-4 py-2 rounded-lg">
                                <ApartmentOutlined className="w-5 h-5 text-indigo-600" />
                                <span className="text-indigo-700 font-medium">
                                    {branches.length} Branches
                                </span>
                            </div>
                        </div>

                        <StatsBar />

                        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-10"></th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:text-gray-700" onClick={() => handleSort("name")}>
                                            <div className="flex items-center">
                                                Branch Name {getSortIcon("name")}
                                            </div>
                                        </th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Contact</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:text-gray-700" onClick={() => handleSort("plan")}>
                                            <div className="flex items-center">
                                                Plan {getSortIcon("plan")}
                                            </div>
                                        </th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Main Users</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sub Branches</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sub Users</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:text-gray-700" onClick={() => handleSort("created_date")}>
                                            <div className="flex items-center">
                                                Created {getSortIcon("created_date")}
                                            </div>
                                        </th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Renewal Year</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Expiry Date</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {filteredBranches.length === 0 ? (
                                        <tr>
                                            <td colSpan="10" className="px-4 py-8 text-center text-gray-500">
                                                <BankOutlined className="w-12 h-12 mb-3 text-gray-300" />
                                                <p>No branches found</p>
                                            </td>
                                        </tr>
                                    ) : (
                                        filteredBranches.map((branch) => {
                                            const isExpanded = expandedRows[branch._id];
                                            const PlanIcon = getPlanDetails(branch.plan).icon;
                                            const planDetails = getPlanDetails(branch.plan);

                                            return (
                                                <React.Fragment key={branch._id}>
                                                    <tr className="hover:bg-gray-50 transition-colors">
                                                        <td className="px-4 py-3">
                                                            <button
                                                                onClick={() => toggleRowExpand(branch._id)}
                                                                className="p-1 hover:bg-gray-200 rounded-lg transition-colors"
                                                            >
                                                                {isExpanded ? (
                                                                    <DownOutlined className="w-4 h-4 text-gray-600" />
                                                                ) : (
                                                                    <RightOutlined className="w-4 h-4 text-gray-600" />
                                                                )}
                                                            </button>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <div className="flex items-center">
                                                                <div className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center mr-3">
                                                                    <BankOutlined className="w-4 h-4 text-indigo-600" />
                                                                </div>
                                                                <div>
                                                                    <p className="font-medium text-gray-900">{branch.name}</p>
                                                                    <p className="text-xs text-gray-500">Ref: {branch.ref}</p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <p className="text-sm text-gray-900 flex items-center">
                                                                <MailOutlined className="w-3 h-3 mr-1 text-gray-400" />
                                                                {branch.email}
                                                            </p>
                                                            <p className="text-xs text-gray-500 flex items-center mt-1">
                                                                <PhoneOutlined className="w-3 h-3 mr-1 text-gray-400" />
                                                                {branch.phone}
                                                            </p>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <span className={`inline-flex items-center px-2 py-1 rounded-lg text-xs font-medium ${planDetails.bg} ${planDetails.text}`}>
                                                                <PlanIcon className="w-3 h-3 mr-1" />
                                                                {planDetails.name}
                                                            </span>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <span className="inline-flex items-center px-2 py-1 bg-blue-100 text-blue-700 rounded-lg text-xs font-medium">
                                                                <UserOutlined className="w-3 h-3 mr-1" />
                                                                {branch.main_branch_users_count || 0}
                                                            </span>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <span className="inline-flex items-center px-2 py-1 bg-green-100 text-green-700 rounded-lg text-xs font-medium">
                                                                <ShopOutlined className="w-3 h-3 mr-1" />
                                                                {branch.sub_branches_count || 0}
                                                            </span>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <span className="inline-flex items-center px-2 py-1 bg-amber-100 text-amber-700 rounded-lg text-xs font-medium">
                                                                <TeamOutlined className="w-3 h-3 mr-1" />
                                                                {branch.total_sub_branch_users || 0}
                                                            </span>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <div className="flex items-center text-sm text-gray-600">
                                                                <CalendarOutlined className="w-3 h-3 mr-1 text-gray-400" />
                                                                {formatDate(branch.created_date)}
                                                            </div>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <div className="flex items-center text-sm text-gray-600">
                                                                {branch.renewed_year || 'N/A'}
                                                            </div>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <div className="flex items-center text-sm text-gray-600">
                                                                {branch.renewed_year
                                                                    ? formatDateExpiry(branch.created_date, branch.renewed_year)
                                                                    : 'N/A'}
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    {isExpanded && (
                                                        <tr>
                                                            <td colSpan="10" className="px-4 py-4 bg-gray-50">
                                                                <div className="space-y-6">
                                                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                                                                        <div className="bg-white p-3 rounded-lg border border-gray-200">
                                                                            <p className="text-xs text-gray-500">Country</p>
                                                                            <p className="font-medium flex items-center mt-1">
                                                                                <GlobalOutlined className="w-4 h-4 mr-1 text-indigo-500" />
                                                                                {branch.address?.country || 'N/A'}
                                                                            </p>
                                                                        </div>
                                                                        <div className="bg-white p-3 rounded-lg border border-gray-200">
                                                                            <p className="text-xs text-gray-500">Total Users</p>
                                                                            <p className="font-medium mt-1">{branch.total_users_count || 0}</p>
                                                                        </div>
                                                                    </div>

                                                                    {branch.main_branch_users?.length > 0 && (
                                                                        <UserTable
                                                                            users={branch.main_branch_users}
                                                                            title={`Main Branch Users - ${branch.name}`}
                                                                            showLoginInfo={true}
                                                                        />
                                                                    )}

                                                                    {branch.sub_branches?.length > 0 && (
                                                                        <div>
                                                                            <h4 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
                                                                                <ApartmentOutlined className="w-4 h-4 mr-2 text-green-600" />
                                                                                Sub Branches ({branch.sub_branches.length})
                                                                            </h4>
                                                                            <SubBranchTable
                                                                                subBranches={branch.sub_branches}
                                                                                mainBranchId={branch._id}
                                                                            />
                                                                        </div>
                                                                    )}

                                                                    {!branch.main_branch_users?.length && !branch.sub_branches?.length && (
                                                                        <div className="text-center py-8 bg-white rounded-lg border border-gray-200">
                                                                            <TeamOutlined className="w-12 h-12 text-gray-300 mb-3" />
                                                                            <p className="text-gray-500">No users or sub-branches found</p>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ScrollWrapper>
            </Loadercomponent>
        </Header>
    );
};

export default BranchesDisplay;